import { RangePickerProps } from "antd/lib/date-picker";
import moment from "moment";

export const disabledDate: RangePickerProps['disabledDate'] = current => {
  return current && current < moment('2023-06-01');
};